import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Layout } from 'app/common/layout'
import { ErrorManagement } from 'app/common/error-management'
import { ProductSheet } from './ProductSheetContainer'
import {
    fetchProductPageData,
    resetProductPageData
} from 'shared/store/product'

type Props = {
    error: any,
    networkError: any,
    location: Object,
    history: Object
}

const ProductComponent = (props: Props) => {
    const { error, networkError, location, history } = props
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchProductPageData(location.pathname, true))
        return () => dispatch(resetProductPageData())
    }, [])

    return (
        <ErrorManagement error={error} networkError={networkError}>
            <Layout background="plain">
                <ProductSheet location={location} history={history} />
            </Layout>
        </ErrorManagement>
    )
}

export { ProductComponent }
